import React from "react";
import { Container } from "./styles";
import dateFormat from "dateformat";
import SVG from "react-inlinesvg";
import useCookieDismissable from "../../hooks/useCookieDismissable";
import { useAppStore } from "../../stores/appStore";
import classNames from "classnames";

const QuotaMessageV1 = ({ subscription }) => {
  const [show, dismiss] = useCookieDismissable("dismissed_quota_message_v1", 60 * 60 * 24 * 7);
  const isSW2 = useAppStore((state) => state.isSW2);

  if (!subscription.activeSubscription || subscription.usesQuota || subscription.data.quota > 0) return null;

  if (!show) return null;

  return (
    <Container className={classNames("quota-message-v1", { sw2: isSW2 })}>
      <div>
        <p>
          Your usage has exceeded the maximum limits for this account. Service will be restored on {dateFormat(subscription.data.currentPeriodEnd, "mmmm dd.")} <br />
          <a href="https://sudowrite.notion.site/About-the-limits-on-the-grandfathered-pricing-plans-46f24b6fd34948edab0760d74009f7d8">Learn more</a> or <a href="mailto:hi@sudowrite.com">email</a> us
          if you'd like to switch to a more flexible plan.
        </p>
        <a
          onClick={(e) => {
            dismiss();
          }}
        >
          <SVG src="/assets/noun_X_2262986.svg"></SVG>
        </a>
      </div>
    </Container>
  );
};

export default QuotaMessageV1;
